import { useStoreActions } from 'stores/global';
import { TaskBarModalProps } from 'features/modalManager/types';

export const useDialog = () => {
  const { add, setActiveId } = useStoreActions(actions => actions.modalManager);

  const openDialog = (payload: TaskBarModalProps) => {
    return new Promise(resolve => {
      // check localstorage for show again
      if (payload.showAgainCheckbox) {
        const dontShowAgain = localStorage.getItem(`${payload.showAgainCheckbox}-showAgain`);
        if (dontShowAgain === 'true') {
          resolve('skip');
          return;
        }
      }
      add({ ...payload, resolve, minimize: false });
      setActiveId(payload.id);
    });
  };

  return { openDialog };
};
